export const joannaWisniewska = {
    'firstName': 'Joanna',
    'lastName': 'Wiśniewska',
    'profession': 'Psychoterapeuta młodzieży i dorosłych, psycholog wojskowy',
    'avatar': 'joanna-wisniewska.webp',
    'slug': 'psychoterapeuta-joanna-wisniewska',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychoterapy', 'adult'],
        // ['group', 'abandonedGroup'],
    ]
}